import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { HvlPrepareModelFieldsUtil, HvlFormConstants } from '@hvlng/framework-core/form';
import { concat, defer, Observable, of } from 'rxjs';

declare module '@angular/forms' {
    interface FormGroup {
        getVal(key: string): any | null;

        setVal(key: string, value: any): void;

        clearVal(key: string): void;

        patchValueWithoutBase<T extends HvlBaseModel>(model: T): void;

        isNull(key: string): boolean;

        setNullIfEmpty(key: string): void;

        ifVal(key: string, onValue: (val: any) => void): void;

        patchValueByFormMode<T extends HvlBaseModel>(model: T, formMode: HvlFormConstants): void;

        setPeopleId(peopleId: number, count?: number): void;

        markAllAsUntouched(): void;
    }

    interface AbstractControl<TValue, TRawValue> {

        valueChangesWithInitialValue(): Observable<TValue>;
    }
}

AbstractControl.prototype.valueChangesWithInitialValue = function (): Observable<any> {
    return concat(defer(() => of(this.value)),this.valueChanges);
};

UntypedFormGroup.prototype.getVal = function (key: string): any | null {
    return this.get(key).value;
};
UntypedFormGroup.prototype.setVal = function (key: string, value: any): void {
    this.get(key).setValue(value);
};
UntypedFormGroup.prototype.clearVal = function (key: string): void {
    this.get(key).setValue(null);
};
UntypedFormGroup.prototype.patchValueWithoutBase = function <T extends HvlBaseModel>(model: T): void {
    this.patchValue(HvlPrepareModelFieldsUtil.clearBaseModelFields(model));
};
UntypedFormGroup.prototype.isNull = function (key: string): boolean {
    return this.get(key).value == null;
};
UntypedFormGroup.prototype.setNullIfEmpty = function (key: string): void {
    if (this.get(key).value == '') {
        this.get(key).setValue(null);
    }
};
UntypedFormGroup.prototype.ifVal = function (key: string, onValue: (val: any) => void): void {
    let newVal = this.get(key)?.value;
    if (newVal != null) {
        onValue(newVal);
    }
};
UntypedFormGroup.prototype.patchValueByFormMode = function <T extends HvlBaseModel>(
    model: T,
    formMode: HvlFormConstants,
): void {
    if (formMode === HvlFormConstants.COPY) {
        this.patchValue(HvlPrepareModelFieldsUtil.clearBaseModelFields(model));
    } else {
        this.patchValue(model);
    }
};
UntypedFormGroup.prototype.setPeopleId = function (peopleId: number, count?: number): void {
    if (count != null) {
        this.setVal('count', count);
    }
    this.setVal('perPeopleId', peopleId);
};
UntypedFormGroup.prototype.markAllAsUntouched = function (): void {
    this.markAsUntouched({ onlySelf: true });
};
